import * as React from 'react';
import {Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText} from '@mui/material';
import Button from '@mui/material/Button';
import { withTranslation } from 'react-i18next';

function DeleteMaintenanceDialog({t, open, handleClose, onDelete, maintenanceId}) {

  const handleDelete = () => {
    onDelete(maintenanceId);
    handleClose();
  };

    return(
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('Delete Vehicle')}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t('Are you sure you want to delete this vehicle?')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t('Cancel')}
          </Button>
          <Button onClick={handleDelete}>{t('Delete')}</Button>
        </DialogActions>
      </Dialog>
    );
}

export default withTranslation()(DeleteMaintenanceDialog);